import router from '@/router/answer'
import { wechatJsSdk } from '../../../plugin/wechatJSSdk'
import { checkScanQrCode } from '@/static/js/zjs'

/** 跳转到结果页面 */
export function toSearchResultPage(isbn, none = 0, fromAnswerPage, type) {
  if (fromAnswerPage) {
    router.push({
      path: '/findbook/findresult',
      query: {
        barCode: isbn,
        none,
        type
      }
    })
  } else {
    window.location.href = `/cms/webapp/home/answer/#/findbook/findresult?barCode=${isbn}&none=${none}&type=${type}`
  }
}
export function scanBookQRCode() {
  return new Promise((resolve, reject) => {
    wechatJsSdk
      .then((wx) => {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['barCode'], // 可以指定扫二维码还是一维码，默认二者都有
          success: (res) => {
            var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
            if (res.errMsg === 'scanQRCode:ok') {
              if (checkScanQrCode(result)) {
                resolve(result)
              } else {
                reject('扫码失败\n请对准书后条形码扫描')
              }
            }
          },
          fail: (err) => {
            console.log(err)
            reject(err.errMsg)
          }
        })
      })
      .catch((e) => {
        console.log(e)
        reject(e.errMsg)
      })
  })
}
